import { useBindProp as o } from "../props.js";
import { makeOptionsSetter as t } from "../../utils/options.js";
var r = t("bubble");

function b(t, b) {
  o(t, {
    setter: r
  }, b.bubble);
}

export default b;